/* ============================================================
   Copper Elixir — "Complete your ritual" bundle upsell
   - Toggles add-ons, recomputes bundle price/savings live.
   - "Add all to cart" adds current product (if not already in cart)
     + selected add-ons, then applies a discount code to the cart.
   Markup: snippets/ritual-upsell.liquid
   ============================================================ */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var m = fmt.match(placeholder);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  // Build the /cart/add.js body, requesting the cart drawer sections so we can
  // re-render + open the drawer without a full page navigation.
  function addBody(items) {
    var cart = getCart();
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return body;
  }

  // After adding: apply a discount code (full nav, required), else open the
  // cart drawer, else fall back to the cart page.
  function finishAdd(response, opts) {
    if (opts.code) {
      var dest = opts.redirect === 'checkout' ? '/checkout' : opts.cartUrl;
      window.location.href = '/discount/' + encodeURIComponent(opts.code) + '?redirect=' + encodeURIComponent(dest);
      return;
    }
    if (opts.redirect === 'checkout') { window.location.href = '/checkout'; return; }
    var cart = getCart();
    if (cart && typeof cart.renderContents === 'function' && response && response.sections) {
      cart.renderContents(response);
      // Clear the empty-cart state so items are visible when adding to an empty cart
      // (mirrors the theme's product-form.js behaviour).
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    } else {
      window.location.href = opts.cartUrl;
    }
  }

  function initRitual(root) {
    if (root.dataset.ceWired === '1') return;
    root.dataset.ceWired = '1';

    // Bundle mode: one hidden product carries the whole bundle price.
    var bundleVariantId = root.getAttribute('data-bundle-variant-id');
    if (bundleVariantId) {
      var bAddBtn = root.querySelector('[data-ritual-add]');
      var bSpin = root.querySelector('.ce-ritual__spinner');
      var bAddUrl = root.getAttribute('data-add-url') || '/cart/add';
      var bCartUrl = root.getAttribute('data-cart-url') || '/cart';
      var bRedirect = root.getAttribute('data-redirect') || 'cart';
      if (bAddBtn) {
        bAddBtn.addEventListener('click', function () {
          bAddBtn.disabled = true;
          if (bSpin) bSpin.hidden = false;
          fetch(bAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(addBody([{ id: bundleVariantId, quantity: 1 }]))
          })
            .then(function (r) { return r.json(); })
            .then(function (response) {
              finishAdd(response, { code: '', redirect: bRedirect, cartUrl: bCartUrl });
              bAddBtn.disabled = false;
              if (bSpin) bSpin.hidden = true;
            })
            .catch(function (e) { console.error(e); bAddBtn.disabled = false; if (bSpin) bSpin.hidden = true; });
        });
      }
      return;
    }

    var cfg = {
      code: root.getAttribute('data-discount-code') || '',
      redirect: root.getAttribute('data-redirect') || 'cart',
      currentProductId: root.getAttribute('data-current-product-id'),
      currentVariantId: root.getAttribute('data-current-variant-id'),
      basePrice: num(root.getAttribute('data-base-price')),
      baseDprice: num(root.getAttribute('data-base-dprice')),
      addUrl: root.getAttribute('data-add-url') || '/cart/add',
      cartUrl: root.getAttribute('data-cart-url') || '/cart',
      money: root.getAttribute('data-money-format') || '${{amount}}',
      saveWord: root.getAttribute('data-save-word') || 'save',
      wasWord: root.getAttribute('data-was-word') || 'was'
    };

    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-upsell]'));
    var nowEl = root.querySelector('[data-ritual-now]');
    var wasEl = root.querySelector('[data-ritual-was]');
    var savingsEl = root.querySelector('[data-ritual-savings]');
    var ctaText = root.querySelector('[data-ritual-cta-text]');
    var ctaBtn = root.querySelector('[data-ritual-add]');
    var spinner = root.querySelector('.ce-ritual__spinner');
    var incartEl = root.querySelector('[data-incart]');
    var baseLabelEl = root.querySelector('[data-base-label]');
    var ctaLabel = ctaText ? (ctaText.textContent.split(' \u2014 ')[0]) : 'Add all to cart';

    var currentInCart = false;

    function selectedAddons() {
      return addons.filter(function (r) {
        return r.getAttribute('data-selected') === 'true' && r.getAttribute('data-unavailable') !== 'true';
      });
    }

    function recompute() {
      var now = cfg.baseDprice;
      var was = cfg.basePrice;
      selectedAddons().forEach(function (r) {
        now += num(r.getAttribute('data-dprice'));
        was += num(r.getAttribute('data-price'));
      });
      var save = was - now;

      if (nowEl) nowEl.textContent = formatMoney(now, cfg.money);
      if (wasEl) {
        if (save > 0) {
          wasEl.textContent = cfg.wasWord + ' ' + formatMoney(was, cfg.money);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }
      if (ctaText) ctaText.textContent = ctaLabel + (save > 0 ? (' \u2014 ' + cfg.saveWord + ' ' + formatMoney(save, cfg.money)) : '');

      var toAdd = (currentInCart ? 0 : 1) + selectedAddons().length;
      if (ctaBtn) ctaBtn.disabled = toAdd === 0;
    }

    function setToggle(row, on) {
      row.setAttribute('data-selected', on ? 'true' : 'false');
      row.classList.toggle('is-selected', on);
      var btn = row.querySelector('[data-upsell-toggle]');
      if (btn) {
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', String(on));
      }
      recompute();
    }

    addons.forEach(function (row) {
      var btn = row.querySelector('[data-upsell-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        setToggle(row, row.getAttribute('data-selected') !== 'true');
      });
    });

    function applyDiscountRedirect() {
      var dest = cfg.redirect === 'checkout' ? '/checkout' : cfg.cartUrl;
      if (cfg.code) {
        window.location.href = '/discount/' + encodeURIComponent(cfg.code) + '?redirect=' + encodeURIComponent(dest);
      } else {
        window.location.href = dest;
      }
    }

    function addBundle() {
      var items = [];
      if (!currentInCart && cfg.currentVariantId) {
        items.push({ id: cfg.currentVariantId, quantity: 1 });
      }
      selectedAddons().forEach(function (r) {
        var id = r.getAttribute('data-variant-id');
        if (id) items.push({ id: id, quantity: 1 });
      });
      if (!items.length) return;

      if (ctaBtn) ctaBtn.disabled = true;
      if (spinner) spinner.hidden = false;

      fetch(cfg.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(addBody(items))
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          finishAdd(response, { code: cfg.code, redirect: cfg.redirect, cartUrl: cfg.cartUrl });
          if (ctaBtn) ctaBtn.disabled = false;
          if (spinner) spinner.hidden = true;
        })
        .catch(function (e) {
          console.error(e);
          if (ctaBtn) ctaBtn.disabled = false;
          if (spinner) spinner.hidden = true;
        });
    }

    if (ctaBtn) ctaBtn.addEventListener('click', addBundle);

    // Detect whether the current product is already in the cart.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pid = String(cfg.currentProductId);
        currentInCart = (cart.items || []).some(function (it) { return String(it.product_id) === pid; });
        if (incartEl) incartEl.hidden = !currentInCart;
        if (baseLabelEl) baseLabelEl.hidden = currentInCart;
        recompute();
      })
      .catch(function () { recompute(); });

    recompute();
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.slice.call(root.querySelectorAll('[data-ritual]')).forEach(initRitual);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
